module.exports = __webpack_public_path__ + "static/media/football_gym_fitness.171fbfbf.jpg";